<app-page-bar></app-page-bar>

<app-page>

  <h2>End Customer Payments</h2>

  <mat-card>

    <app-list-filter-group>
      <app-text-list-filter [list]="list"></app-text-list-filter>
      <app-reset-list-filter [list]="list"></app-reset-list-filter>
    </app-list-filter-group>

    <mat-table [dataSource]="list" matSort (matSortChange)="list.setSort($event.active, $event.direction)"
               matSortDisableClear="true" [matSortActive]="list.state.sort.key"
               [matSortDirection]="list.state.sort.direction">

      <ng-container matColumnDef="changed">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.changed | date:'shortDate'}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="invoiceId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Invoice</mat-header-cell>
        <mat-cell *matCellDef="let element"><a [routerLink]="['/invoices/', element.invoiceId]">{{element.invoiceId}}</a></mat-cell>
      </ng-container>

      <ng-container matColumnDef="payment">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.payment ? 'Payment' : 'Compensation' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="sum">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Sum</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.sum | currency:'EUR' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.description }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Created</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.created | date:'short'}}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columns" style="cursor: pointer"></mat-header-row>

      <mat-row *matRowDef="let row; columns: columns;" matRipple></mat-row>

    </mat-table>

    <mat-paginator *ngIf="(list.loadingObservable | async) !== true"
                   [length]="list.total"
                   [pageIndex]="list.state.pager.page - 1"
                   [pageSize]="list.state.pager.size"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   showFirstLastButtons="true"
                   (page)="list.setPage($event.pageIndex + 1, $event.pageSize)">
    </mat-paginator>

    <app-list-loader [list]="list"></app-list-loader>

  </mat-card>

</app-page>
